import { Injectable, Injector,  } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, switchMap, take, filter } from 'rxjs/operators';
import { AuthService } from '@app/utils/auth/auth.service';
import { throwError } from 'rxjs';
import { BehaviorSubject, Observable, from } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { HTTP } from '@ionic-native/http/ngx';
import { Platform, NavController  } from '@ionic/angular';

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'head' | 'delete' | 'upload' | 'download';

@Injectable()
export class Interceptor implements HttpInterceptor {

   private isRefreshing = false;
   private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
   viewCtrl

   constructor(
      viewCtrl: NavController,
      private authService: AuthService,
      private router: Router,
      private nativeHttp: HTTP,
      private platform: Platform
   ) {
   }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      const token = this.authService.getAccessToken();

      const host = request.url.split('//')[1].split('/')[0];


      let str = host;
      let result = str.includes("hometech.red")

      request = request.clone({ headers: request.headers.set('Accept', '*/*') }); //application/json
      request = request.clone({ headers: request.headers.set('Access-Control-Allow-Headers', 'Authorization, Expires, Pragma, DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range') });

      if( token && result )  {
         // Genero la cabecera
         const headers = new HttpHeaders().set("Authorization", "Bearer " + token);

         // Añado la cabecera a la peticion actual
         const AuthRequest = request.clone( { headers: headers });

         if (this.platform.is('cordova')) {
            // Devuelvo la nueva peticion modificada
            return from(this.handleNativeRequest(AuthRequest)).pipe(catchError(error => {
               // Solo me interesa si el error es un 401 (Unauthorized)
               if (error instanceof HttpErrorResponse && error.status === 401) {


                  // Trato el error
                  return this.handle401Error(request, next).pipe(
                     // Si no ha sido posible obtener un token nuevo
                     catchError(subError => {
                        this.authService.removeTokens();
                        alert(1)
                        this.router.navigate(['/clave']);

                        return throwError(subError);
                     })
                  );
               } else if (error instanceof HttpErrorResponse && error.status === 403) {
                  this.authService.removeTokens();

                  // cierro todos los modales.
                  this.viewCtrl.dismiss();
                  alert(2)
                  this.router.navigate(['/clave']);
                  return throwError(error);
               } else {
                  return throwError(error);
               }
            }));
         } else {
            // Devuelvo la nueva peticion modificada
            return next.handle(AuthRequest).pipe(catchError(error => {
               // Solo me interesa si el error es un 401 (Unauthorized)
               if (error instanceof HttpErrorResponse && error.status === 401) {
                  // Trato el error

                  return this.handle401Error(request, next).pipe(
                     // Si no ha sido posible obtener un token nuevo
                     catchError(subError => {
                        this.authService.removeTokens();
                        alert(3)
                        this.router.navigate(['/clave']);
                        return throwError(subError);
                     })
                  );
               } else if (error instanceof HttpErrorResponse && error.status === 403) {
                  alert(4)
                  this.authService.removeTokens();
                  this.router.navigate(['/clave']);
                  return throwError(error);
               } else {
                  return throwError(error);
               }
            }));
         }
      } else {
         // Devuelvo la peticion original
         if (!this.platform.is('cordova')) { return next.handle(request); }
         return from(this.handleNativeRequest(request));
      }
   }

   private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
      // Debo prevenir que varias peticiones intenten obtener un token nuevo
      if (!this.isRefreshing) {
         this.isRefreshing = true;
         this.refreshTokenSubject.next(null);

         // Solicito a la API un token nuevo
         return this.authService.refreshToken().pipe(
            switchMap((tokens: any) => {
               this.isRefreshing = false;
               this.refreshTokenSubject.next(tokens.access_token);
               return next.handle(this.addToken(request, tokens.access_token));
            })
         );
      } else {
         // Espero a recibir el token nuevo
         return this.refreshTokenSubject.pipe(
            filter(token => token != null),
            take(1),
            switchMap(access_token => {
               return next.handle(this.addToken(request, access_token));
            })
         );
      }
   }

   private addToken(request: HttpRequest<any>, access_token: string) {
      return request.clone({
         setHeaders: {
            'Authorization': `Bearer ${access_token}`
         }
      });
   }

   private async handleNativeRequest(request: HttpRequest<any>): Promise<HttpResponse<any>> {
      const headerKeys = request.headers.keys();
      const headers = {};

      headerKeys.forEach((key) => {
         headers[key] = request.headers.get(key);
      });

      try {
         await this.platform.ready();

         const method = <HttpMethod> request.method.toLowerCase();

         const nativeHttpResponse = await this.nativeHttp.sendRequest(request.url, {
            method: method,
            data: request.body,
            headers: headers,
            serializer: 'json',
         });

         let body;

         try {
            body = JSON.parse(nativeHttpResponse.data);
         } catch (error) {
            body = { response: nativeHttpResponse.data };
         }

         const response = new HttpResponse({
            body: body,
            status: nativeHttpResponse.status,
            headers: request.headers, //nativeHttpResponse.headers,
            url: nativeHttpResponse.url,
         });

         return Promise.resolve(response);
      } catch (error) {
         if (!error.status) { return Promise.reject(error); }

         const response = new HttpResponse({
            // body: JSON.parse(error.error),
            body: error.error,
            status: error.status,
            headers: error.headers,
            url: error.url,
         });

         return Promise.reject(response);
      }
   }
}